import { Field } from "react-final-form";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { DropdownInput } from "../../common/fields";
import Section from "../../common/section";
import { GlobalConstants } from "../../../constants";

const AccountPreferencesForm = ({ disabled, enterprise }) => {
  const intl = useIntl();

  const allowedLanguages = GlobalConstants.LANGUAGES.filter(
    (lang) =>
      enterprise?.languageConfiguration?.allowedLanguages?.includes(
        lang.code
      ) || lang.value === "en"
  ).map((lang) => ({
    ...lang,
    id: lang.code,
    name: lang.name,
  }));

  return (
    <div className="flex flex-column gap-2">
      <Section title="language_settings">
        <div className="grid">
          <div className="col-12 md:col-6 lg:col-4">
            <Field
              component={DropdownInput}
              name="preferredLanguage"
              label={intl.formatMessage({
                id: "preferred_language",
              })}
              options={allowedLanguages}
              disabled={disabled}
            />
          </div>
        </div>
      </Section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  enterprise: state.global?.enterprise,
});

export default connect(mapStateToProps)(AccountPreferencesForm);
